import { createAdminAuthClient } from "@sunfish/auth/admin";

export const adminAuthClient = createAdminAuthClient(
  import.meta.env.DEV ? "http://localhost:3000" : undefined
);

export type { AdminAuthSession } from "@sunfish/auth/admin";
